/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useMemo } from 'react';

import { Button, Container, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'block',
      position: 'relative',
      width: '100%',
    },
    containerAdditionalFile: {
      alignItems: 'center',
      border: '1px solid #999999',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '8px',
      padding: '4px 8px',
    },
    typographyAdditionalFile: {
      color: '#172B4D',
      fontSize: '12px',
      fontWeight: 'bold',
    },
  };
});

export default ({ updatedAdditionalFile, onViewAdditionalFileRecord, onCloseAdiditonalFileRecord }) => {
  const classes = useStyles();

  const handleViewAdditionalFile = useCallback(() => {
    if (onViewAdditionalFileRecord) onViewAdditionalFileRecord();
  }, [onViewAdditionalFileRecord]);

  const handleCloseAdditionalFilerecord = useCallback(() => {
    if (onCloseAdiditonalFileRecord) onCloseAdiditonalFileRecord();
  }, [onCloseAdiditonalFileRecord]);

  const renderedUpdatedAdditionalFile = useMemo(() => {
    if (!updatedAdditionalFile?.resourceId) return null;
    const textTitle = updatedAdditionalFile?.success ? 'Successfully uploaded the additional file!' : 'Failed to upload the additional file';
    return (
      <div className={classes.containerAdditionalFile}>
        <Typography className={classes.typographyAdditionalFile}>{textTitle}</Typography>

        <div>
          <Button size="small" variant="text" onClick={() => handleCloseAdditionalFilerecord()}>
            Close
          </Button>
          <Button size="small" variant="outlined" onClick={() => handleViewAdditionalFile()}>
            View Record
          </Button>
        </div>
      </div>
    );
  }, [classes, updatedAdditionalFile, handleViewAdditionalFile, handleCloseAdditionalFilerecord]);

  return (
    <Container disableGutters className={classes.container}>
      {renderedUpdatedAdditionalFile}
    </Container>
  );
};
